<template>
    <span></span>
    <!-- <ul class="breadCrumbs">
        <li v-for="(v, i) in breadcrumbs" :key="i">
            <router-link :to="v.path">{{v.name}}</router-link>
            <span class="arrow" v-if="i != breadcrumbs.length - 1">＞</span>
        </li>
    </ul> -->
</template>

<script>
export default {
    name: 'Breadcrumb',
    props: {
        breadcrumbs: {
            type: Array
        }
    }
}
</script>

<style scoped lang="sass">
span
    display: none
.breadCrumbs
    font-size: 1.2rem
    padding: 20px
    width: 100%
    li
        display: inline-block
        a
            color: $grayColor
            position: relative
            &::after
                background: $mainColor
                bottom: -4px
                content: ''
                height: 2px
                left: 0
                position: absolute
                transform: scale(0, 1)
                transform-origin: left top
                transition: transform .3s
                width: 100%
            &:hover
                &::after
                    transform: scale(1, 1)
    .arrow
        display: inline-block
        margin: 0 2px
</style>
